import { getImageProps } from '@hungryroot/image';

type Props = {
  src: string;
  testid?: string;
  alt: string;
  className: string;
};

export function ProductCardImage({ className, alt, testid, src }: Props) {
  return (
    <img
      data-testid={`${testid}-image`}
      {...getImageProps({
        src,
        width: 300,
      })}
      alt={alt}
      className={className}
    />
  );
}
